import { useQuery } from '@tanstack/react-query';

import apiClient from '../../../../api/axios';
import type {
  TCategoryListResponse,
  TPrinterListResponse,
} from '../menu/schemas';

const CATEGORY_URL = '/menu/category';
const PRINTER_URL = '/restaurant-printer';

export const QUERY_KEYS = {
  menuCategories: 'menu-categories',
  printers: 'menu-printers',
} as const;

export const useGetCategoryList = (restaurantId: string) => {
  return useQuery({
    queryKey: [QUERY_KEYS.menuCategories, restaurantId],
    queryFn: async () => {
      const response = await apiClient.get<TCategoryListResponse>(
        `${CATEGORY_URL}?pageSize=100000&pageNum=1&filter__idRestaurant=${restaurantId}`,
        { headers: { 'Restaurant-ID': restaurantId } },
      );
      const rows = response.data?.data?.rows ?? [];
      return rows.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
    },
    enabled: !!restaurantId,
  });
};

export const useGetPrinterList = (restaurantId: string) => {
  return useQuery({
    queryKey: [QUERY_KEYS.printers, restaurantId],
    queryFn: async () => {
      const response = await apiClient.get<TPrinterListResponse>(PRINTER_URL, {
        headers: { 'Restaurant-ID': restaurantId },
      });
      return response.data?.data?.rows ?? [];
    },
    enabled: !!restaurantId,
  });
};

export { useGetAllergens } from '../../allergens/services';
export { useGetAttributes } from '../../menu-attributes/services';
